module.exports = __webpack_public_path__ + "img/brand-8.6dc3c0c7.svg";